import Entity from '@/api/entity'

export default class FileEntity extends Entity {
  module

  get fullPath () {
    return this.virtual_path === '/' ? '/' + this.name : this.virtual_path + '/' + this.name
  }

  set fullPath (path) {
    if (path === '/') {
      this.virtual_path = '/'
      this.name = ''
    }
    const splitPath = path.split('/')
    this.name = splitPath.pop()
    this.virtual_path = splitPath.join('/')
  }
}
